<template>
  <div class="faqItem" @click="handleClick()">
    <h3 :class="['faqItem__heading', { 'faqItem__heading--open': isOpen }]" v-html="this.heading" />
    <transition name="faq-item">
      <div v-bind:class="['faqItem__description', { 'faqItem__description--open': isOpen }]" v-if="isOpen" v-html="this.description" />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FaqItem',
  data () {
    return {
      isOpen: false
    }
  },
  props: {
    'heading': {
      'type': String,
      'default': ''
    },
    'description': {
      'type': String,
      'default': ''
    }
  },
  methods: {
    handleClick: function () {
      this.isOpen = !this.isOpen
      console.log('handleClick', this.isOpen)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/components/FaqItem.vue